import React, { Component } from "react";
import "../css/aboutPage.css";

class AboutPage extends Component {
    render() {
        return (
            <div className="aboutHolder">
                <div className="aboutHolderInner">
                    <div style={{ height: "85px", width: "125px", marginTop: "-80px", marginLeft: "auto", marginRight: "auto" }}>
                        <img src={require('../images/about-logo.png')} style={{ width: 100 + "%", objectFit: "contain" }} />
                    </div>
                    <div className="aboutHeaderText">About Allplans</div>

                    <div style={{ width: 90 + "%", marginRight: "auto", marginLeft: "auto" }}>
                        <div className="aboutSmallerText">With over 30 years of experience, nationally renowned designer, Bob Chatham created Chatham Design Group (Allplans) as a way to provide you with a large variety of house plans to help you find the home plan that's right for you. We understand that choosing a house plan design is a great step in building your new home. Our goal is to provide you with the highest quality overall experience in purchasing your new home plan design. </div>
                        <div className="aboutSmallerText">Chatham Design Group members include designers, registered architects, and professional engineers from across the nation and Canada. Our members include members of the American Institute of Building Design (AIBD) and/or The American Institute of Architects (AIA). We are proud to present thousands of house plan designs from designers with award winning house plans and designers that have been published nationally in the industry's leading books and magazines.</div>
                        <br />
                    </div>

                </div>
            </div>
        );
    }
}

export default AboutPage;